import { decoderHttp, useRequest } from "../config";

export const useDecoder = () => {
  const { post } = useRequest(decoderHttp, "Decoder");

  const postAuthToken = async (
    clientId: string,
    clientSecret: string
  ): Promise<any> => {
    const body = {
      clientId,
      clientSecret,
    };
    const { data } = await post("login", body);
    return data;
  };

  const postFindByPlate = async (
    plate: string,
    token: string
  ): Promise<any> => {
    const body = {
      plate,
    };
    const { data } = await post("findByPlate", body, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return data;
  };

    const postFindByVin = async (
      vin: string,
      token: string
    ): Promise<any> => {
      const body = {
        vin,
      };
      const { data } = await post("findByVin", body, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return data;
    };

  return {
    postAuthToken,
    postFindByPlate,
    postFindByVin,
  };
};
